import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcStarWithCirecle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 20,
		rx: 10,
		fill: "#666B75"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.13867 14.4199L8.24219 11.0605L5.39062 8.99023H8.90625L9.99023 5.65039L11.084 8.99023H14.6094L11.7578 11.0605L12.8516 14.4199L9.99023 12.3398L7.13867 14.4199Z",
		fill: "white"
	})]
});
export default SvgIcStarWithCirecle;
